import { useEffect, useState } from 'react';
import { SITE } from '../data/site';
import { registerSsrBodyClasses } from '../lib/body-class';

const DISMISSED_KEY = 'vanevery-fullscript-promo-dismissed-v1';

export default function FullscriptPromoBanner() {
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === 'undefined') return true;

    try {
      return window.sessionStorage.getItem(DISMISSED_KEY) !== 'true';
    } catch {
      return true;
    }
  });

  if (isVisible) registerSsrBodyClasses(['fullscript-promo-active']);
  useEffect(() => {
    document.body.classList.toggle('fullscript-promo-active', isVisible);
    return () => document.body.classList.remove('fullscript-promo-active');
  }, [isVisible]);

  const dismiss = () => {
    try {
      window.sessionStorage.setItem(DISMISSED_KEY, 'true');
    } catch {
      // The banner should still be dismissible when browser storage is unavailable.
    }

    setIsVisible(false);
  };

  if (!isVisible) return null;

  const promotion = SITE.promotions.fullscript;

  return (
    <aside className="fullscript-promo-banner" aria-label="Fullscript dispensary savings">
      <div className="fullscript-promo-inner">
        <span className="fullscript-promo-copy">
          <strong>{promotion.headline}</strong>
          <span>{promotion.description}</span>
        </span>
        <a
          className="fullscript-promo-link"
          href={promotion.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {promotion.cta}
          <span aria-hidden="true"> &rarr;</span>
          <span className="sr-only"> (opens in a new tab)</span>
        </a>
      </div>
      <button
        type="button"
        className="fullscript-promo-close"
        aria-label="Dismiss Fullscript savings banner"
        onClick={dismiss}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </aside>
  );
}
